import React, { Component } from "react";
import { connect } from "react-redux";
import { txtBox, comboBox } from "../utils/Forms";
import ContentHeader from "./ContentHeader";
import Table from "../utils/table";
import { search, destroy } from "../actions";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/lib/Modal";
import { prop } from "ramda";

class SearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: {
        first_name: "",
        last_name: "",
        phone_number: ""
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.search = this.search.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;

    let search = { ...this.state.search, [name]: target.value };

    this.setState({ ...this.state, search });
  }

  search(e) {
    try {
      this.props.searchAction(this.state.search);
    } catch (err) {}
    e.preventDefault();
  }

  render() {
    const { first_name, last_name, phone_number } = this.state.search;
    let form = (
      <div className="">
        <form onSubmit={this.search}>
          <div className="clearfix" />
          {txtBox("Last Name", "last_name", last_name, this)}
          {txtBox("First Name", "first_name", first_name, this)}
          {txtBox("Phone number", "phone_number", phone_number, this)}

          <input
            type="submit"
            value="Search"
            className="btn btn-success down-btn"
          />
        </form>
      </div>
    );
    return form;
  }
}

class SearchResult extends Component {
  render() {
    let { results, handleEvent } = this.props;
    let tableFields = [
      { name: "last_name", header: "Last Name" },
      { name: "first_name", header: "First Name" },
      { name: "phone_number", header: "Phone Number" },
      { name: "date_of_birth", header: "Date of birth" },
      { name: "residential_address", header: "Address" },
      { name: "edit", type: "action", header: "", action: "editMember" },
      { name: "remove", type: "action", header: "", action: "tryRemoveMember" }
    ];

    let content = <div />;
    let columnWrappers = {};
    if (results.length !== 0) {
      content = (
        <div>
          <h3> Search Results </h3>
          <Table
            tableData={results}
            tableFields={tableFields}
            handleEvent={handleEvent}
            columnWrappers={columnWrappers}
          />
          <div />
        </div>
      );
    }

    return <div> {content}</div>;
  }
}

const RemoveReasons = ["Duplicate Member", "Member Deceased", "other"];

class RemoveUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: RemoveReasons[0],
      member: props.member
    };

  }

  componentWillReceiveProps(props) {
    this.setState({ member: props.member });
  }

  handleChange = event => {
    const target = event.target;
    this.setState({ reason: target.value });
  };

  hideModal = () => {
    this.props.hideModal();
  };

  doRemoveMember = () => {
    const { member, reason } = this.state;
    this.props.removeMember(member.id, reason);
  };

  render() {
    const { reason, member } = this.state;
    if (!this.props.showModal) {
      return null;
    }

    return (
      <Modal show={this.props.showModal} onHide={this.hideModal} bsSize="small">
        <Modal.Header closeButton>
          <Modal.Title>Remove User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            <div>
              Are you sure to wan't to remove {member.first_name}{" "}
              {member.last_name} ?
            </div>
            <br />
          </div>
          <div className="row">
            <div className="col-md-12">
              {comboBox(
                "Reason",
                "reason_id",
                reason,
                this,
                RemoveReasons,
                [],
                { klass: "col-md-12" }
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="remove-buttons">
                <input
                  onClick={this.doRemoveMember}
                  className="btn btn-success pull-right"
                  type="submit"
                  value="Remove"
                />
                <a
                  className="btn btn-default pull-right"
                  style={{ marginRight: 10 }}
                  onClick={this.hideModal}
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

class DropDown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false
    }
  }

  toggleMe = () => {
    this.setState({show: !this.state.show});
  }

  render() {
    const {show} = this.state;
    let classes = ["dropdown-menu"];
    if(show) {
      classes = ["show-dropdownmenu", ...classes]
    }
    return (
        <div className="btn-group" role="group">
          <button
            onClick={this.toggleMe}
            type="button"
            className="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Downloads
          </button>
          <div className={classes.join(" ")} aria-labelledby="btnGroupDrop1">
            <a className="dropdown-item" href="#" onClick={this.props.downloadMembers}>
              Active Members
            </a>
            <a className="dropdown-item" href="#" onClick={this.props.downloadDeceased}>
              Deceased Members
            </a>
          </div>
        </div>
    );
  }
}

class Search extends Component {
  constructor(props) {
    super(props);
    this.handleEditMember = this.handleEditMember.bind(this);
    this.state = {
      removeMember: false
    };
  }

  componentDidMount() {
    this.props.reset();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.deleteCompleted) {
      this.clearRemoveMember();
      this.props.removeModalClosed();
    }
  }

  handleEditMember(eventName, data) {
    this[eventName](data);
  }

  downloadMemberList = e => {
    e.preventDefault();
    this.props.downloadMembers('active');
  };

  downloadDeceasedList = e => {
    e.preventDefault();
    this.props.downloadMembers('deceased');
  }

  editMember(member) {
    this.props.history.push(`/members/${member.id}/edit`);
  }

  clearRemoveMember() {
    this.setState({ removeMember: false, memberToRemove: null });
  }

  tryRemoveMember(member) {
    this.setState({ removeMember: true, memberToRemove: member });
  }

  removeMember = (id, reason) => {
    this.props.removeMember({ id, reason });
  };

  hideRemoveModal = () => {
    this.clearRemoveMember();
  };

  renderDownloadButtons() {
    return <DropDown downloadMembers={this.downloadMemberList}  downloadDeceased={this.downloadDeceasedList}/>;
  }

  render() {
    const { results, searchForMember, searching } = this.props;

    let newMemberLink = (
      <Link to="/members/new" className="btn btn-primary">
        {" "}
        New Member{" "}
      </Link>
    );

    const DownloadButton = (
      <button onClick={this.downloadMemberList} className="btn btn-default">
        Download Members
      </button>
    );

    const searchIndicator =
      searching === true ? <p> Searching....... </p> : null;
    return (
      <div>
        <ContentHeader title="Search for member">
          <span className="pull-right">
            {newMemberLink}
            {/* {DownloadButton} */}
            {" "}
            {this.renderDownloadButtons()}
          </span>
        </ContentHeader>
        <SearchForm searchAction={searchForMember} />
        <div className="divider"> </div>
        {searchIndicator}
        <SearchResult handleEvent={this.handleEditMember} results={results} />
        <RemoveUser
          showModal={this.state.removeMember}
          hideModal={this.hideRemoveModal}
          member={this.state.memberToRemove}
          removeMember={this.removeMember}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reset() {
      dispatch({ type: "MEMBER_RESET" });
    },
    downloadMembers(kind) {
      dispatch({ type: "DOWNLOAD_MEMBERS", data: kind });
    },
    searchForMember(searchParams = {}) {
      dispatch({ type: "MEMBER_SEARCHING" });
      dispatch(search("members", searchParams));
    },
    removeMember(payload) {
      dispatch(destroy("member", payload));
    },
    removeModalClosed() {
      dispatch({type:"REMOVE_MODAL_CLOSED"});
    }
  };
};

const mapStateToProps = state => {
  return {
    results: state.search.results,
    searching: state.search.searching,
    deleteCompleted: state.search.deleteCompleted
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/components/Search.js